import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PickSelect } from "@/components/docs/Fields";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const DocDialog = ({ open, kind, heading, editing, empty, normalize, onClose, onSaved, children }) => {
  const [form, setForm] = useState(empty());
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));
  useEffect(() => { if (open) setForm(editing ? { ...empty(), ...editing } : empty()); }, [open, editing]);

  const fillFromPortfolio = async (p) => {
    try {
      const { data } = await api.get(`/${kind}/prefill`, { params: { portfolio_id: p.id } });
      setForm((f) => ({ ...f, ...Object.fromEntries(Object.entries(data).filter(([k]) => k === "portfolio_id" || f[k] === "" || f[k] == null)) }));
      toast.success("Portföy bilgileri dolduruldu");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const submit = async (e) => {
    e.preventDefault();
    const payload = normalize(form);
    try {
      if (editing) await api.put(`/${kind}/${editing.id}`, payload);
      else await api.post(`/${kind}`, payload);
      toast.success("Kaydedildi");
      onSaved();
      onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl max-h-[92vh] overflow-y-auto" data-testid={`${kind}-dialog`}>
        <DialogHeader><DialogTitle>{editing ? `${heading} düzenle` : `Yeni ${heading.toLocaleLowerCase("tr")}`}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid md:grid-cols-2 gap-3">
            <div><Label className="text-xs">Kayıt adı *</Label><Input data-testid={`${kind}-title-input`} required minLength={2} value={form.title || ""} onChange={(e) => set({ title: e.target.value })} /></div>
            <PickSelect url="/portfolios" label="Portföyden doldur" placeholder={form.portfolio_id ? "Portföy bağlı – değiştir" : "Portföy seçin"} testid={`${kind}-portfolio-pick`}
              toLabel={(p) => `${p.title} · ${p.district}`} onPick={fillFromPortfolio} />
          </div>
          {children(form, set)}
          <div className="flex justify-end gap-2 pt-3 border-t">
            <Button type="button" variant="outline" onClick={onClose}>İptal</Button>
            <Button data-testid={`${kind}-save-btn`} type="submit" className="bg-emerald-600 hover:bg-emerald-700">Kaydet</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
